import {inject, Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {TranslocoService} from '@jsverse/transloco';
import {MatDialog} from '@angular/material/dialog';
import {ErrorDialog} from '../../shared/dialogs/error/error.dialog';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  translocoService = inject(TranslocoService);
  dialog = inject(MatDialog);

  handleError(error: HttpErrorResponse | undefined, dialogTitle?: string) {
    if (!error) {
      return;
    }

    let errorMessage = this.createErrorMessage(error);
    if (!dialogTitle) {
      dialogTitle = this.translocoService.translate("error.title.default");
    }

    this.dialog.open(ErrorDialog, {
      data: {
        title: dialogTitle,
        message: errorMessage
      }
    });
  }

  createErrorMessage(error: HttpErrorResponse) {
    let errorMessage: string;

    switch (error.status) {
      case 401:
        errorMessage = this.translocoService.translate("error.unauthorized");
        break;
      case 403:
        errorMessage = this.translocoService.translate("error.forbidden");
        break;
      case 404:
        errorMessage = this.translocoService.translate("error.notFound");
        break;
      case 500:
        errorMessage = this.translocoService.translate("error.internalServerError");
        break;
      case 400:
        errorMessage = this.translocoService.translate("error.badRequest");
        break;
      default:
        errorMessage = this.translocoService.translate("error.unexpected");
    }

    return errorMessage;
  }
}
